import { Box } from '@mui/material';
import {
    SAVE_CELEBRATION_FLASH_COLOR,
    SAVE_CELEBRATION_FLASH_MS,
} from '../utils/saveCelebrations';

type SaveCelebrationOverlayProps = {
    active: boolean;
    /** Bump on each celebration so the CSS animation restarts cleanly. */
    nonce?: number;
};

/**
 * Full-screen cyan flash (same look as Notes save celebration).
 * Opacity is driven only by the keyframe animation — do not also toggle
 * `opacity` via `active`, or the flash reappears when the animation ends
 * (looks like a double blink / double save).
 */
export const SaveCelebrationOverlay = ({ active, nonce = 0 }: SaveCelebrationOverlayProps) => (
    <>
        <style>{`@keyframes projectSaveFlash { 0% { opacity: 0.95; transform: scale(1); } 40% { opacity: 0.65; transform: scale(1.02); } 100% { opacity: 0; transform: scale(1.04); } }`}</style>
        <Box
            key={active ? `flash-${nonce}` : 'flash-idle'}
            sx={{
                position: 'fixed',
                inset: 0,
                bgcolor: SAVE_CELEBRATION_FLASH_COLOR,
                opacity: 0,
                pointerEvents: 'none',
                zIndex: 1400,
                boxShadow: 'inset 0 0 200px 40px rgba(64,224,208,0.25)',
                backdropFilter: 'blur(1px)',
                animation: active
                    ? `projectSaveFlash ${SAVE_CELEBRATION_FLASH_MS}ms ease-out forwards`
                    : 'none',
            }}
        />
    </>
);
